import type { Case } from '../../domain/initial-cases';
import type { UpdateCase } from '../contexts/AppDataContext';

// D6 (answered 2026-06-09): the two Accept paths — the OnboardingTab button
// and the Applications-list button — converge on the tab's full-validation
// behavior. An executed Registrant Agreement is required before forwarding
// to vetting, and both paths write the identical payload (the audit detail
// records which surface accepted).
// #766 — the agreement half of the gate, exported so the case progress tracker
// asks the same question (domain/case-progress.ts). The Onboarding tab's Send
// to vetting button disables on it; the Applications list shows a warning on
// it and, if clicked anyway, this function's validation-error result.
export function hasExecutedAgreement(c: Pick<Case, 'onboarding'>): boolean {
  return !!c.onboarding?.agreementExecuted;
}

export function acceptOnboarding(
  c: Case,
  updateCase: UpdateCase,
  source: 'onboarding-tab' | 'applications-list',
): { ok: boolean; message?: string } {
  const ob = c.onboarding;
  if (!hasExecutedAgreement(c)) {
    return {
      ok: false,
      message: 'A valid executed Registrant Agreement must be confirmed before data can be forwarded to vetting.',
    };
  }
  const now = new Date().toISOString();
  // #286: the vetting SLA deadline is NOT sent. The API derives it from this
  // status→IN_REVIEW transition using its own clock, 15 business days (#692);
  // it was previously computed here off the analyst's workstation clock, which
  // made a compliance deadline client-supplied. The PATCH response carries the
  // server's value back, so nothing downstream needs it in the request.
  updateCase(c.id, {
    onboarding: { ...ob, status: 'READY_FOR_VETTING', oaForwardedAt: now },
    status: 'IN_REVIEW',
    action: { code: 'ONBOARDING_ACCEPTED', detail: { source } },
  });
  return { ok: true };
}
